export default function Logo({ size = 44, withText = false, dark = false }) {
  return (
    <span className="inline-flex items-center gap-3">
      <img
        src="/assets/logo.jpeg"
        alt="Desert Coast Immigration logo"
        width={size}
        height={size}
        className="rounded-full object-cover ring-2 ring-sand/70 shadow-sm"
        style={{ width: size, height: size }}
        data-testid="brand-logo"
      />
      {withText && (
        <span className={`leading-none whitespace-nowrap ${dark ? "text-cream" : "text-espresso"}`}>
          <span className="block font-serif font-semibold tracking-wide text-base sm:text-lg">
            Desert Coast
          </span>
          <span className="block text-[0.6rem] font-sans font-semibold tracking-[0.3em] uppercase opacity-80 mt-1">
            Immigration
          </span>
        </span>
      )}
    </span>
  );
}
